import useAuth from '@fhs-legacy/frontend/src/hooks/auth/use-auth';
import useDebounceEffect from '@fhs-legacy/frontend/src/hooks/use-debounce-effect';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { IAppliedRewards } from '@fhs-legacy/frontend/src/state/loyalty/hooks/types';
import { useOffersContext } from '@fhs-legacy/frontend/src/state/offers';
import { useServiceModeContext } from '@fhs-legacy/frontend/src/state/service-mode';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';

export function useCartPriceOrder() {
  /* initializes the price order call and the getOrder polling, can be available on cart and checkout as well as other pages, currently only cart;
  has an interval check where it will price after 15 minutes also found in cart context
  */
  const appliedLoyaltyRewards: IAppliedRewards = useAppSelector(
    selectors.loyalty.selectAppliedLoyaltyRewards
  );
  const isRewardApplied = Object.keys(appliedLoyaltyRewards).length;

  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const incentiveApplied = isRewardApplied || selectedOffer;

  const {
    cartEntries,
    tryPricing,
    serverOrder,
    serverOrderLoading,
    shouldSkipPriceOrder,
    setShouldSkipPriceOrder,
  } = useCartContext();

  const { serviceMode } = useServiceModeContext();

  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const { isStoreAvailable } = useStoreContext();
  const { selectedOffer: selectedCBAOffer, selectedOfferCartEntry } = useOffersContext();
  const { user } = useAuth();
  const rewardChanged = user?.details?.loyaltyTier;

  // rewardsApplied depends on cartEntries, causing double triggers
  const appliedLoyaltyRewardsArray = useAppSelector(
    selectors.loyalty.selectAppliedLoyaltyRewardsArray
  );

  const handleRestoreCartErrorPricing = () =>
    shouldSkipPriceOrder && setShouldSkipPriceOrder(false);

  useDebounceEffect(
    () => {
      if (!isStoreAvailable || !serviceMode) {
        return;
      }

      handleRestoreCartErrorPricing();
      tryPricing();
    },
    250,
    [
      cartEntries,
      appliedLoyaltyRewardsArray,
      appliedOffers,
      isStoreAvailable,
      serviceMode,
      selectedCBAOffer,
      selectedOfferCartEntry,
      rewardChanged,
    ]
  );

  return {
    serverOrder,
    serverOrderLoading,
    serverOrderTotal: serverOrder?.cart?.subTotalCents,
    incentiveApplied,
  };
}
